import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";

const ResetPassword = () => {
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errors, setErrors] = useState({});
  const [serverMessage, setServerMessage] = useState("");

  const { token } = useParams();
  const navigate = useNavigate();
  const API_URL = process.env.REACT_APP_API_URL;

    //toast 
  const Toast = Swal.mixin({
    toast: true,
    position: "bottom-end",
    showConfirmButton: false,
    timer: 2000,
  });

  const errorStyle = {
    border: "1px solid #e53935",
    backgroundColor: "#ffeaea"
  };

    // -------- Validate --------
  const validate = () => {
    let temp = {};

    if (!newPassword.trim()) temp.newPassword = "Required";
    if (!confirmPassword.trim()) temp.confirmPassword = "Required";
    if (newPassword && confirmPassword && newPassword !== confirmPassword) {
      temp.confirmPassword = "Passwords do not match!";
    }

    setErrors(temp);

    return Object.keys(temp).length === 0;
  };

  const handleResetPassword = async (e) => {
    e.preventDefault();
    if (!validate()) {
      Toast.fire({
        icon: "error",
        title: "Please fix the highlighted fields."
      });
      return;
    }

    try {
      const res = await axios.post(`${API_URL}/auth/reset-password/${token}`, {
        newPassword: newPassword,
      });
      Toast.fire({
        icon: "success",
        title: "Password reset successful!",
      });
      navigate("/account");
    } catch (err) {
      setServerMessage(err.response?.data?.message || "Password reset failed!");
    }
  };

  return (
    <section className="account py-80">
      <div className="container container-lg">
        <div className="row justify-center">
          <div className="col-xl-6">
            <div className="border border-gray-100 rounded-16 px-24 py-40">
              <h6 className="text-xl mb-32">Reset Password</h6>
              <form onSubmit={handleResetPassword}>
                <div className="mb-24">
                  <label className="text-neutral-900 text-lg mb-8 fw-medium">
                    New Password
                  </label>
                  <input
                    type="password"
                    className="common-input"
                    style={errors.newPassword ? errorStyle : {}}
                    placeholder="Enter new password"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    required
                  />
                </div>
                <div className="mb-24">
                  <label className="text-neutral-900 text-lg mb-8 fw-medium">
                    Confirm Password
                  </label>
                  <input
                    type="password"
                    className="common-input"
                    style={errors.confirmPassword ? errorStyle : {}}
                    placeholder="Enter new password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    required
                  />
                </div>
                <button type="submit" className="btn btn-main py-18 px-40">
                  Reset Password
                </button>
              </form>
              {serverMessage && (
                <p className="mt-24 text-center text-sm text-danger">  {serverMessage}  </p>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ResetPassword;
